const initialState = {
    loading: false , 
    products: [],
    error: ""
}

const productsReducer = (state=initialState , action)=>{
    switch (action.type){
        case "FETCH_PRODUCTS_REQUEST":
            return {
                ...state,
                loading: true
            };
        case "FETCH_PRODUCTS_SUCCESS":
            return {
                ...state , 
                loading: false,
                products: action.payload
            };
        case "FETCH_PRODUCTS_FAILURE":
            return {
                loading: false,
                products: [],
                error: true
            };  
        default : return state          
    }
}

export default productsReducer;